import { createBrowserRouter } from 'react-router'

import { ProtectedLayout } from '@/features/auth/ProtectedLayout'

/**
 * Rotas em modo data do React Router 8.
 *
 * O dashboard e o wizard entram por `lazy`: a rota `/login` é a primeira que
 * qualquer pessoa carrega e o orçamento dela é 300 KB gzip (§7.8).
 *
 * `/transfers/:id` e `/transfers/new` renderizam o mesmo dashboard — o drawer e
 * o wizard abrem sobre ele. Assim o deep link de um caso mostra a tabela por
 * trás, e fechar o drawer não recarrega a lista.
 */
export const router = createBrowserRouter([
  {
    path: '/login',
    lazy: async () => {
      const { default: LoginPage } = await import('@/features/auth/LoginPage')
      return { Component: LoginPage }
    },
  },
  {
    path: '/',
    Component: ProtectedLayout,
    children: [
      {
        index: true,
        lazy: async () => {
          const { DashboardPage } = await import('@/features/dashboard/DashboardPage')
          return { Component: DashboardPage }
        },
      },
      {
        path: 'transfers/new',
        lazy: async () => {
          const { DashboardPage } = await import('@/features/dashboard/DashboardPage')
          return { Component: DashboardPage }
        },
      },
      {
        path: 'transfers/:id',
        lazy: async () => {
          const { DashboardPage } = await import('@/features/dashboard/DashboardPage')
          return { Component: DashboardPage }
        },
      },
    ],
  },
  {
    path: '*',
    lazy: async () => {
      const { NotFoundPage } = await import('@/features/NotFoundPage')
      return { Component: NotFoundPage }
    },
  },
])
